import { useState } from "react";
import { Alert, Button, Typography } from "@mui/material";
import RegisterForm from "../../../../../components/Shared/RegisterForm";
import authService from "../../../../../services/auth.service";
import { useTheme } from '@mui/material/styles';

import { statratRed } from "../../../../../config/constants";

type RegisterType = {
    setIsLogin: (v: boolean) => void;
    isLoading: boolean;
    setIsLoading: (v: boolean) => void;
    setRegisterSuccess: (v: boolean) => void;
}

const Register = ({ setIsLogin, isLoading, setIsLoading, setRegisterSuccess }: RegisterType) => {
    const theme = useTheme();
    // User validation
    const [alert, setAlert] = useState("");

    const handleSignup = (props: any) => {
        authService.signup(
            props.businessName,
            props.email,
            props.password,
            props.userType,
            props.mobile,
            props.addressLine1,
            props.addressLine2,
            props.country,
            props.state,
            props.city,
            props.postalCode
        )
        .then(response => {
            if (response.c === 1) {
                setRegisterSuccess(true);
                setIsLogin(true);
            } else {
                setAlert(response.message);
            }
        });
    }

    return (
        <>
        <Typography variant="h4">Register</Typography>
        <RegisterForm
            handleSignup={handleSignup}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            autoFillColor={theme.palette.mode === "light" ? "white" : "#121212"}
        />
        { alert !== "" && 
            <Alert severity="error" sx={{ width: '100%' }}>{alert}</Alert>
        }
        <Typography>
            Already have an account?
            <Button
                variant="text"
                sx={{ color: statratRed, backgroundColor: 'transparent' }}
                onClick={() => { setIsLogin(true) }}
            >
                Login
            </Button>
        </Typography>
        </>
    )
}

export default Register;
